import Vue from "vue";
import LoadingSpinner from "./svg/LoadingSpinner";
import LeftArrowIcon from "./svg/LeftArrowIcon";
import RightArrowIcon from "./svg/RightArrowIcon";
import AddIcon from "./svg/AddIcon";
import XIcon from "./svg/XIcon";
import ZoomInIcon from "./svg/ZoomInIcon";
import Child from "./layout/Child";

// Components that are registered globaly.
[
  Child,
  LoadingSpinner,
  LeftArrowIcon,
  RightArrowIcon,
  XIcon,
  AddIcon,
  ZoomInIcon
].forEach(Component => {
  Vue.component(Component.name, Component);
});
